/**
 * Private Route Component
 * Protects routes that require authentication
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, ownerOnly = false }) => {
  const { isAuthenticated, isOwner, isSuperuser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (ownerOnly && !isOwner() && !isSuperuser()) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
